import React, {Component} from 'react'

class PlayerIna {
    constructor(id, container) {

        this.id = this._parseID(id);
        this.container = container;
    }

    get imageURL() {
        return Promise.resolve('https://www.ina.fr/images_v2/512x384/' + this.id + '.jpeg')
    }

    play() {
        this.container.innerHTML = "<iframe width='100%' height='100%' frameborder='0' marginheight ='0' marginwidth='0' scrolling='no' src='https://player.ina.fr/player/embed/" + this.id + "/1/1b0bd203fbcd702f9bc9b10ac3d0fc21/wide/1'></iframe>"
    }

    stop() {
    }

    set onPlayCallback(fn) {
        if (typeof fn === "function")
            this._onPlay = fn;
    }

    _onPlay() {

    }

    //
    // UTILS
    //
    _parseID(id) {
        if (id.indexOf('/') === -1)
            return id;

        let exp = new RegExp('player.ina.fr/player/embed/([^"&?/ ]*?)/', 'i')
        let match = id.match(exp);
        if (match) {
            return match[1];
        }
        return id;
    }
}

export default (PlayerIna)


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/player/players/PlayerIna.js